"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrrigationRollingSchedule = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const typeName = 'IrrigationRollingSchedule';
class IrrigationRollingSchedule extends datamodel_core_1.ModelCommon {
    constructor(ob) {
        super(ob.type || typeName, ob);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            Name: {
                type: 'RelatedType',
                editable: false,
                label: 'Name',
                name: 'Name',
                description: 'Name of schedule eg Westerly',
                objectTypeId: 'User',
                direction: iotv_v3_types_1.PathDirection.child,
                edgeTypeId: 'Irrigation_Rolling_Schedule_has_Name_User',
            },
            timeCreated: { type: 'String', editable: true, label: 'Time Created', name: 'timeCreated', description: 'Date and time schedule was created' },
            userCreated: { type: 'String', editable: true, label: 'User Created ', name: 'userCreated', description: 'User that created schedule' },
            areaCovered: { type: 'String', editable: true, label: 'Area covered', name: 'areaCovered', description: 'Aggregate of area covered by irrigation ' },
            current_zone: { type: 'String', editable: true, label: 'current_zone', name: 'current_zone' },
            intended_start: { type: 'String', editable: true, label: 'intended_start', name: 'intended_start', description: 'Time for irrigator to turn on' },
            pause: { type: 'Boolean', editable: true, label: 'pause', name: 'pause' },
            remaining_duration: {
                type: 'String',
                editable: true,
                label: 'remaining_duration',
                name: 'remaining_duration',
                description: 'Duration of time irrigator is still required to run',
            },
            waterApplied: {
                type: 'String',
                editable: true,
                label: 'Water applied',
                name: 'waterApplied',
                description: 'Calculated amount of water to be applied at x pressure for y duration',
            },
        };
    }
}
exports.IrrigationRollingSchedule = IrrigationRollingSchedule;
